import { Link } from 'react-router-dom';
import CategoryCard from '@/components/feature/CategoryCard';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            浏览分类
          </h2>
          <p className="text-sm text-foreground-500">探索你感兴趣的视频内容领域</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <CategoryCard key={cat.id} category={cat} />
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/category/documentary"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-all duration-300 whitespace-nowrap"
          >
            浏览全部分类
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}